
<template>
	<div>
		<TopNav/>
		<div class="container">
			<div class="columns">
				<div id="main" class="column">
			<!-- End Profile header -->
			<section class="login">
			<div class="columns">
				<div class="column">
					<form class="is-maxed">
						<h1>Forgot Password</h1>
                        <p>Please enter your email address below and we will send you information for resetting your password.</p>
						<label class="label">Email</label>
						<div class="field is-maxed">
							<div class="control has-icons-left is-expanded">
								<input class="input" type="text" placeholder="Email" v-model="email">
								<span class="icon is-small is-left">
								<i class="fa fa-user"></i>
								</span>
							</div>
						</div>
						<div class="field is-maxed">
							<div class="control">
								<a class="button is-small is-link" @click.prevent.stop="submit()">Submit</a>
							</div>
						</div>
					</form>
				</div>
			</div>
			</section>
		</div>
			</div>
		<div class="columns is-paddingless">
	<div class="column is-paddingless">
		<div class="footer">
			<div class="container">
				<div class="columns">
					<div class="column">
						<p>
							©Copyright 2020 Psychic Portal. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
		</div>
	</div>
</template>

<script>
	import TopNav from "../TopNav.vue"

	export default {
		components: {
			TopNav
		},
		data() {
			return {
                email: ""
			}
		},
		methods: {
            async submit() {
                await this.$root.$data.setters.forgotPassword(this.$root.$data.state, this.email)
				this.$notify({
					group: 'global',
					type: 'success',
					title: 'Email Sent',
					text: 'Your password recovery email has been sent. Check your spam folder if you\'re unable to find it.',
				})
				this.$router.push("/login")
            }
		}
	}
</script>